/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FrontendSettings
 */
export interface FrontendSettings {
    /**
     * 
     * @type {string}
     * @memberof FrontendSettings
     */
    azureClientId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FrontendSettings
     */
    azureAuthority?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FrontendSettings
     */
    azureApiScope?: string | null;
}

/**
 * Check if a given object implements the FrontendSettings interface.
 */
export function instanceOfFrontendSettings(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FrontendSettingsFromJSON(json: any): FrontendSettings {
    return FrontendSettingsFromJSONTyped(json, false);
}

export function FrontendSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrontendSettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'azureClientId': !exists(json, 'azureClientId') ? undefined : json['azureClientId'],
        'azureAuthority': !exists(json, 'azureAuthority') ? undefined : json['azureAuthority'],
        'azureApiScope': !exists(json, 'azureApiScope') ? undefined : json['azureApiScope'],
    };
}

export function FrontendSettingsToJSON(value?: FrontendSettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'azureClientId': value.azureClientId,
        'azureAuthority': value.azureAuthority,
        'azureApiScope': value.azureApiScope,
    };
}

